import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { waitForOneTrust } from 'utils/gdpr/oneTrust';
// import s from 'base/bolt/boltApp.sss';

if (typeof window !== 'undefined') {
	// Reload page if OneTrust's "allow sale of my personal info" toggle is changed
	const reloadOnConsentUpdate = async () => {
		await waitForOneTrust();

		let needsReload = false;
		// SPD_BG is the group, USP is "a placeholder category to force UI elements to appear" for the same group, we could use either
		const allowTargeted = () => !!window.OptanonActiveGroups?.includes(',SPD_BG,');

		let currentlyAllowTargeted = allowTargeted();
		window.addEventListener('consent.onetrust', () => {
			let prev = currentlyAllowTargeted;
			currentlyAllowTargeted = allowTargeted();
			if (prev !== currentlyAllowTargeted) {
				needsReload = true;
			}
		});

		window.addEventListener('OTConsentApplied', () => needsReload && location.reload());
	};
	reloadOnConsentUpdate();
}

export default class BoltApp extends BaseComp.default {
}
